import { Component } from "react";
 
class CommonComponent extends Component {

}
export default CommonComponent;